import React from "react";
// import "./ConfirmDelete.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";

const ConfirmDelete = ({ isOpenModal, onCloseModal, id, setRefreshEventData }) => {
  if (!isOpenModal) return null;

  const handleDelete = async () => {
    try {
      const payload = {
        id
      };
      const response = await apiServiceHandler("DELETE", "api/calendar/events", { ...payload })
      if (response.auth) {
        toastr.success(response.message);
        setRefreshEventData(true);
        onCloseModal();
      }
    } catch (error) {
      toastr.error('Something went wrong!');
      console.log('Something went wrong! ', error)
    }
  }

  return (
    <Modal
      show={isOpenModal}
      onHide={onCloseModal}
      dialogClassName="custom-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the event
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onCloseModal}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #949a9e",
            color: "#949a9e",
          }}
        >
          No
        </Button>
        <Button
          variant="primary"
          onClick={handleDelete}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #d1b794",
            color: "#d1b794",
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDelete;
